import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import BorderColorRoundedIcon from '@mui/icons-material/BorderColorRounded';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { useForm, Controller } from 'react-hook-form';
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import * as React from 'react';
import dayjs from 'dayjs';
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { MobileDatePicker } from '@mui/x-date-pickers';
import { useState } from 'react';
import { styled } from '@mui/material/styles';
import { PickersActionBarProps } from '@mui/x-date-pickers/PickersActionBar';
import { createStyles, DialogActions, makeStyles } from '@mui/material';
import { PickersModalDialog } from '@mui/x-date-pickers/internals/components/PickersModalDialog';
import { useHorsesStore } from '../../../stores/horses'
import { getEventById, getEventByName } from './utils';
import { toJS } from 'mobx';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

const App: React.FC<{ name: string; control: any; date?: string; canEdit?: boolean, limitMax?: Date, width?: number, onlyYear?: boolean }> = (props) => {
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down('sm'));
    return <Controller
        name={props.name}
        control={props.control}
        render={({ field: { onChange, value, ref } }) =>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                {matches == true ? <MobileDatePicker

                    disabled={props.canEdit === false ? true : false}
                    ref={ref}
                    value={value}
                    views={props.onlyYear == true ? ["year"] : ['year', 'day']}
                    onChange={onChange}
                    maxDate={props.limitMax}
                    inputFormat={props.onlyYear == true ? 'yyyy' : "dd/MM/yyyy"}
                    DialogProps={{
                        sx: {

                            ".MuiButtonBase-root": {
                                padding: '8px !important',
                                background: 'transparent !important'
                            },
                            "div.MuiYearPicker-root > .PrivatePickersYear-modeDesktop > .PrivatePickersYear-yearButton": {
                                padding: '0 !important',
                                background: 'transparent !important'
                            },
                            ".PrivatePickersYear-root.PrivatePickersYear-modeMobile > .PrivatePickersYear-yearButton": {
                                padding: '0 !important',
                                background: 'transparent !important'
                            },
                            "div.MuiYearPicker-root > .PrivatePickersYear-modeDesktop > .Mui-selected": {
                                background: '#408697 !important'
                            },
                            "div.MuiYearPicker-root > .PrivatePickersYear-modeMobile > .Mui-selected": {
                                background: '#408697 !important'
                            },
                            ".MuiPickersDay-root.Mui-selected": {
                                background: '#408697 !important'
                            }

                        }
                    }}
                    renderInput={(params) => <ResponsiveTextField {...params}
                        sx={{ width: props.width ? props.width : '100%' }}
                        name={props.name}
                        InputProps={{
                            ...params.InputProps,
                            sx: {
                                width: '100%',
                                height: 30,
                                borderRadius: 0,
                                '& .MuiIconButton-root': {
                                    padding: '8px !important',
                                    background: 'transparent !important'
                                },
                            }
                        }}
                    />}
                /> : <DatePicker

                    disabled={props.canEdit === false ? true : false}
                    ref={ref}
                    value={value}
                    views={props.onlyYear == true ? ["year"] : ['year', 'day']}
                    onChange={onChange}
                    maxDate={props.limitMax}
                    inputFormat={props.onlyYear == true ? 'yyyy' : "dd/MM/yyyy"}
                    PopperProps={{
                        sx: {
                            ".MuiButtonBase-root": {
                                padding: '8px !important',
                                background: 'transparent !important'
                            },
                            "div.MuiYearPicker-root > .PrivatePickersYear-modeDesktop > .PrivatePickersYear-yearButton": {
                                padding: '0 !important',
                                background: 'transparent !important'
                            },
                            ".PrivatePickersYear-root.PrivatePickersYear-modeMobile > .PrivatePickersYear-yearButton": {
                                padding: '0 !important',
                                background: 'transparent !important'
                            },
                            "div.MuiYearPicker-root > .PrivatePickersYear-modeDesktop > .Mui-selected": {
                                background: '#408697 !important'
                            },
                            "div.MuiYearPicker-root > .PrivatePickersYear-modeMobile > .Mui-selected": {
                                background: '#408697 !important'
                            },
                            ".MuiPickersDay-root.Mui-selected": {
                                background: '#408697 !important'
                            }

                        }
                    }}
                    renderInput={(params) => <ResponsiveTextField {...params}
                        sx={{ width: props.width ? props.width : '100%' }}
                        name={props.name}
                        InputProps={{
                            ...params.InputProps,
                            sx: {
                                height: 30,
                                borderRadius: 0,
                                '& .MuiIconButton-root': {
                                    padding: '8px !important',
                                    background: 'transparent !important'
                                },
                            }
                        }}
                    />}
                />}



            </LocalizationProvider>
        }
    />


}
const ResponsiveTextField = styled(TextField)(({ theme }) => ({
    [theme.breakpoints.down('sm')]: {
        width: '100%',

    },
    [theme.breakpoints.up('sm')]: {
        flex: 1,

    },
}));
export const DatePickerWithBtn: React.FC<{ onChange: (date) => void, eventId: number; name: string; email: string; profileId: string; address: string; }> = (props) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedDate, handleDateChange] = useState('');
    const [anchorEl, setAnchorEl] = React.useState(null);
    const stores = useHorsesStore()
    const handleClick = (event) => {
        setIsOpen(true);
        setAnchorEl(event.currentTarget);
        stores.updateRequesEvent({
            date: selectedDate,
            email: props.email,
            name: props.name,
            type: props.eventId,
            address: props.address,
            profileId: props.profileId
        })
    };

    return <LocalizationProvider dateAdapter={AdapterDateFns} onAccept={() => { console.log('onAccept') }} >
        <DatePicker
            onOpen={() => {
                setIsOpen(true)

                stores.updateRequesEvent({
                    date: selectedDate,
                    email: props.email,
                    name: props.name,
                    type: props.eventId,
                    address: props.address,
                    profileId: props.profileId
                })

            }}
            closeOnSelect={false}
            open={isOpen}
            value={selectedDate}
            onChange={(val) => {
                if (val) {
                    const date = dayjs(val).format('DD/MM/YYYY')
                    handleDateChange(val)
                    props.onChange(val)
                    stores.request && stores.updateRequesEvent({ ...stores.request, date: date })
                }
            }}
            onClose={() => setIsOpen(false)}
            PopperProps={{
                placement: "bottom-end",
                anchorEl: anchorEl,
                sx: {
                    ".MuiButtonBase-root": {
                        padding: '8px !important',
                        background: 'transparent !important'
                    },
                    ".MuiButtonBase-root.MuiButton-contained": {
                        padding: '8px !important',
                        background: '#408697 !important'
                    },
                    "& .PrivatePickersYear-yearButton ": {
                        padding: '0 !important',
                        background: 'transparent !important'
                    },
                    "& .Mui-selected": {
                        background: '#408697 !important'
                    },
                    "div.MuiYearPicker-root > .PrivatePickersYear-modeDesktop > .Mui-selected": {
                        background: '#408697 !important'
                    },
                    "div.MuiYearPicker-root > .PrivatePickersYear-modeMobile > .Mui-selected": {
                        background: '#408697 !important'
                    },
                },

            }}
            DialogProps={{
                sx: {
                    ".MuiButtonBase-root": {
                        padding: '8px !important',
                        background: 'transparent !important'
                    },
                    ".MuiButtonBase-root.MuiButton-contained": {
                        padding: '8px !important',
                        background: '#408697 !important'
                    },
                    "& .PrivatePickersYear-yearButton ": {
                        padding: '0 !important',
                        background: 'transparent !important'
                    },
                    "& .Mui-selected": {
                        background: '#408697 !important'
                    },
                    "div.MuiYearPicker-root > .PrivatePickersYear-modeDesktop > .Mui-selected": {
                        background: '#408697 !important'
                    },
                    "div.MuiYearPicker-root > .PrivatePickersYear-modeMobile > .Mui-selected": {
                        background: '#408697 !important'
                    },
                }

            }}
            renderInput={(params) => (
                <ReqVisitBtn variant="outlined" startIcon={<StyledBorderIcon />} onClick={handleClick}>
                    REQUEST VISIT
                </ReqVisitBtn>
            )}

            components={{
                ActionBar: MyActionBar,
            }}

        />

    </LocalizationProvider>


}

const MyActionBar = ({
    onAccept,
    onCancel,
}: PickersActionBarProps) => {
    const stores = useHorsesStore()
    return (
        <DialogActions>
            <Button onClick={() => {
                onAccept()
                stores.sendVisitRequest()
                console.log(toJS(stores.request))
            }}
                variant="contained"
                sx={{
                    backgroundColor: '#408697 !important'
                }}
            > request </Button>
            <Button onClick={onCancel} variant="outlined"> close </Button>
        </DialogActions>
    );
};
const ActionReqBtn = styled(Button)`
    background-color: #408697 !important;
    color: white !important;
    font-weight: 900 !important;
    font-size: 14px !important;

`
const StyledBorderIcon = styled(BorderColorRoundedIcon)`
    color:#408697;
`
const StyledBtn = styled(Button)`
    background-color: transparent !important;
    color: white !important;
    font-weight: 900 !important;
    font-size: 14px !important;
    text-transform: none !important;
`
const FilledBtn = styled(StyledBtn)`
    background-color: #408697 !important;
    font-weight: 900 !important;
    font-family: inherit;
    height:40px !important;
    width:250px !important;
    font-size: 12px !important;
    border-radius:0 !important;
`
const OutlinedShortBtn = styled(FilledBtn)`
    font-size:10px  !important;
    background-color: #fff !important;
    color: black !important;
    border-color:#3333  !important;
    width:185px !important;
    font-family:inherit !important;
    padding:0  !important;
    width: 140px !important;
    height: 35px !important;
`
const ReqVisitBtn = styled(OutlinedShortBtn)`

`
export default App
